import React from 'react';
import DismissRecommendationRequestMaker from './dismiss-recommendation-request-maker';
import { DismissRecommendationRequestBroker, UndoDismissalRequestBroker } from './dismissal-result/response-broker';
import { Requester } from './requester';
import UndoDismissalRequestMaker from './undo-dismissal-request-maker';
const useDismissal = ({
  endpoint = '/gateway/api/graphql',
  contextResolver
}) => {
  /**
   * Dismisses a recommendation for a given product.
   */
  const dismissRecommendation = React.useCallback(productId => {
    const dismissRecommendationRequestMaker = new DismissRecommendationRequestMaker(endpoint);
    const requester = new Requester(new DismissRecommendationRequestBroker());
    return requester.fetch(dismissRecommendationRequestMaker.makeRequest({
      productId,
      contextResolver
    }));
  }, [contextResolver, endpoint]);

  /**
   * Undoes a dismissal for a given product.
   */
  const undoDismissal = React.useCallback(productId => {
    const undoDismissalRequestMaker = new UndoDismissalRequestMaker(endpoint);
    const requester = new Requester(new UndoDismissalRequestBroker());
    return requester.fetch(undoDismissalRequestMaker.makeRequest({
      productId,
      contextResolver
    }));
  }, [contextResolver, endpoint]);
  return {
    dismissRecommendation,
    undoDismissal
  };
};
export default useDismissal;